import { injectSagas } from '../../store/sagas';


export default store => ({
  path : 'registration',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      const SignupContainer = require('./containers/RegistrationContainer.js').default;
      const sagas = require('sagas/sagas').default;

      injectSagas(store, { key: 'sagas', sagas });

      cb(null, SignupContainer);
    }, 'signup');
  },
});



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/routes/Registration/index.js